// Utility to convert numbers to words (supports up to 99999999)
export function numberToWords(amount: number): string {
    const a = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    if (isNaN(amount) || amount === 0) return "Zero";

    const num = Math.floor(amount);
    const paise = Math.round((amount - num) * 100);

    if (num.toString().length > 9) return "Overflow";
    let n = ("000000000" + num).slice(-9).match(/.{1,2}/g);
    if (!n) return "";
    let str = "";
    str += n[0] !== "00" ? (a[Number(n[0])] || b[Number(n[0][0])] + " " + a[Number(n[0][1])]) + " Crore " : "";
    str += n[1] !== "00" ? (a[Number(n[1])] || b[Number(n[1][0])] + " " + a[Number(n[1][1])]) + " Lakh " : "";
    str += n[2] !== "00" ? (a[Number(n[2])] || b[Number(n[2][0])] + " " + a[Number(n[2][1])]) + " Thousand " : "";
    str += n[3] !== "00" ? (a[Number(n[3])] || b[Number(n[3][0])] + " " + a[Number(n[3][1])]) + " Hundred " : "";
    if (n[4] !== "00") {
        if (str !== "") str += "and ";
        const val = Number(n[4]);
        if (val < 20) {
            str += a[val] + " ";
        } else {
            str += b[Number(n[4][0])] + (Number(n[4][1]) ? " " + a[Number(n[4][1])] : "") + " ";
        }
    }
    str = str.trim();

    if (paise > 0) {
        let paiseStr = "";
        if (paise < 20) {
            paiseStr = a[paise];
        } else {
            paiseStr = b[Math.floor(paise / 10)] + (paise % 10 ? " " + a[paise % 10] : "");
        }
        return `${str} Rupees and ${paiseStr} Paise`;
    }
    return `${str} Rupees`;
}

